var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.333 3.33342C18.333 2.41294 17.5868 1.66675 16.6663 1.66675H14.9997C14.0792 1.66675 13.333 2.41294 13.333 3.33341V16.6667C13.333 17.5872 14.0792 18.3334 14.9997 18.3334H16.6663C17.5868 18.3334 18.333 17.5872 18.333 16.6667V3.33342ZM14.9997 3.33341L16.6663 3.33342V16.6667H14.9997V3.33341Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 7.50008C12.4997 6.57961 11.7535 5.83341 10.833 5.83341H9.16634C8.24587 5.83341 7.49967 6.57961 7.49967 7.50008V16.6667C7.49967 17.5872 8.24587 18.3334 9.16634 18.3334H10.833C11.7535 18.3334 12.4997 17.5872 12.4997 16.6667V7.50008ZM9.16634 7.50008H10.833V16.6667H9.16634V7.50008Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66634 11.6667C6.66634 10.7463 5.92015 10.0001 4.99967 10.0001H3.33301C2.41253 10.0001 1.66634 10.7463 1.66634 11.6667V16.6667C1.66634 17.5872 2.41253 18.3334 3.33301 18.3334H4.99967C5.92015 18.3334 6.66634 17.5872 6.66634 16.6667V11.6667ZM3.33301 11.6667H4.99967V16.6667H3.33301V11.6667Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbDashboardIcon);
export default __webpack_public_path__ + "static/media/ub-dashboardIcon.14c5743491f976d0b40b0fa2895834a1.svg";
export { ForwardRef as ReactComponent };